import Container from '@mui/material/Container';
import Typography from '@mui/material/Typography';
import React from 'react';
import { useOrgNavigate } from "app/routes/useOrgNavigate";
import { appRoutes } from '@/routes/constants';

const AddOrg = (): JSX.Element => {
    const navigate = useOrgNavigate();

    const onClick = () => {
        navigate(appRoutes.AUTH_SETUP_BUILD);
    };

    return (
        <Container
            style={{
                display: 'flex',
                justifyContent: 'center',
                flexDirection: 'row',
                padding: '0',
            }}
            sx={{
                '&:hover': {
                    cursor: 'pointer',
                },
            }}
            onClick={onClick}
        >
            <Typography color="primary" variant="bodyMedium">
                Create a new Organization
            </Typography>
        </Container>
    );
};

export default AddOrg;
